import * as qs from "query-string";

export default function paramsSerializer(params) {
  return qs.stringify(params, { arrayFormat: "bracket", encode: false });
}
